module.exports = __webpack_public_path__ + "assets/materialdesignicons-webfont.eot?c28acdf1c1f9c45ff40b25d6719e4c6c";